import {encode} from "../utils/EncodeHtmlEntities";

export default {
  bind(el, binding) {
    el.innerText = encode(binding.value)
  },
  update(el, binding) {
    el.innerText = encode(binding.value)
  }
}
